import { useQuery } from '@tanstack/react-query'
import { useUserId } from '~/components/user/SessionProvider'
import { getUserInterest } from './readInterests'

export function useInterest() {
  const userId = useUserId()

  return useQuery({
    queryKey: ['interests', userId],
    queryFn: () => (userId ? getUserInterest(userId) : Promise.resolve(null)),
    enabled: !!userId,
  })
}
